/** Query keys for the expense-type (category) reference list. */
export const expenseTypeKeys = {
  all: () => ['expense-type'] as const,
  list: () => [...expenseTypeKeys.all(), 'list'] as const,
} as const;
